import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Typography, Button, notification } from "antd";
import { format } from "date-fns";
import axios from "axios";
import { useConfigQuery } from "../../../queries/useConfig";

const { Title } = Typography;

const Home = () => {
  const { data: config, isLoading, error } = useConfigQuery();

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  const [loading, setLoading] = useState(false);
  const [idLoja, setIDLoja] = useState(null);

  // 🔹 Busca loja do usuário
  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        )
        .then((response) => {
          setIDLoja(response.data.id);
        });
    }
  }, [accessToken, idUser]);

  // 🔹 Download do XML
  const baixarXml = (xml) => {
    const blob = new Blob([xml], {
      type: "application/xml;charset=utf-8",
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "pdv-vendas.xml";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // 🔹 Calcula período
  const calcularPeriodo = (periodo) => {
    const hoje = new Date();

    switch (periodo) {
      case "HOJE":
        return {
          dataInicial: format(hoje, "yyyy-MM-dd"),
          dataFinal: format(hoje, "yyyy-MM-dd"),
        };

      case "ONTEM": {
        const ontem = new Date();
        ontem.setDate(ontem.getDate() - 1);
        return {
          dataInicial: format(ontem, "yyyy-MM-dd"),
          dataFinal: format(ontem, "yyyy-MM-dd"),
        };
      }

      case "SEMANA_ATUAL": {
        const primeiroDiaSemana = new Date(hoje);
        primeiroDiaSemana.setDate(hoje.getDate() - hoje.getDay());
        return {
          dataInicial: format(primeiroDiaSemana, "yyyy-MM-dd"),
          dataFinal: format(hoje, "yyyy-MM-dd"),
        };
      }

      case "MES_ATUAL": {
        const primeiroDiaMes = new Date(
          hoje.getFullYear(),
          hoje.getMonth(),
          1
        );
        return {
          dataInicial: format(primeiroDiaMes, "yyyy-MM-dd"),
          dataFinal: format(hoje, "yyyy-MM-dd"),
        };
      }

      case "MES_PASSADO": {
        const primeiroDiaMesPassado = new Date(
          hoje.getFullYear(),
          hoje.getMonth() - 1,
          1
        );
        const ultimoDiaMesPassado = new Date(
          hoje.getFullYear(),
          hoje.getMonth(),
          0
        );
        return {
          dataInicial: format(primeiroDiaMesPassado, "yyyy-MM-dd"),
          dataFinal: format(ultimoDiaMesPassado, "yyyy-MM-dd"),
        };
      }

      default:
        return null;
    }
  };

  // 🔹 Busca e baixa XML
  const buscarProdutosPorPeriodo = (periodo) => {
    if (!accessToken || !idLoja) return;

    const datas = calcularPeriodo(periodo);
    if (!datas) return;

    setLoading(true);

    axios
      .get(
        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/pdveventos/exportar/xml/${idLoja}/${datas.dataInicial}/${datas.dataFinal}/0/1/0`,
        {
          headers: {
            Accept: "application/xml",
            Authorization: "Bearer " + accessToken,
          },
          responseType: "text",
        }
      )
      .then((response) => {
        baixarXml(response.data);
        notification.success({
          message: "XML gerado e baixado com sucesso",
        });
      })
      .catch(() => {
        notification.error({
          message: "Erro ao gerar XML",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <Content>
        <Title level={4} style={{ textAlign: "center" }}>
          Gerar XML das Vendas Para Integração NAPP
        </Title>

        <ButtonsWrapper>
          <Button
            type="primary"
            block
            loading={loading}
            disabled={!idLoja}
            onClick={() => buscarProdutosPorPeriodo("HOJE")}
          >
            Dia Atual
          </Button>

          <Button
          type="primary"
            block
            loading={loading}
            disabled={!idLoja}
            onClick={() => buscarProdutosPorPeriodo("ONTEM")}
          >
            Ontem
          </Button>

          <Button
          type="primary"
            block
            loading={loading}
            disabled={!idLoja}
            onClick={() => buscarProdutosPorPeriodo("SEMANA_ATUAL")}
          >
            Semana Atual
          </Button>

          <Button
          type="primary"
            block
            loading={loading}
            disabled={!idLoja}
            onClick={() => buscarProdutosPorPeriodo("MES_ATUAL")}
          >
            Mês Atual
          </Button>

          <Button
          type="primary"
            block
            loading={loading}
            disabled={!idLoja}
            onClick={() => buscarProdutosPorPeriodo("MES_PASSADO")}
          >
            Mês Passado
          </Button>
        </ButtonsWrapper>
      </Content>
    </Container>
  );
};

// 🔹 Styled Components
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
`;

const Content = styled.div`
  width: 100%;
  max-width: 360px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default Home;
